import React from "react";
import * as Mui from "@mui/material";
import * as env from "shared/env";
import { saveUser } from "redux/slice/authentication";
import { bindActionCreators, Dispatch } from "redux";
import { UserPartial } from "model/user";
import { connect } from "react-redux";
import { getUserUnsafe } from "redux/selector";
import { RootState } from "redux/store";
import { Switch } from "component/shared/switch";

interface State {
	submitted: boolean;
	listingAgentRouting: boolean,
}

interface OwnProps {
	checked?: boolean;
	onToggle?: (checked: boolean) => void;
}

interface Props	extends
	OwnProps,
	ReturnType<typeof mapStateToProps>,
	ReturnType<typeof mapDispatchToProps> {
}

const mapStateToProps = (state: RootState) => {
	const user = getUserUnsafe(state);
	return {
		user,
		authError: state.authentication.error
	};
};

const mapDispatchToProps = (dispatch: Dispatch) => bindActionCreators({
		saveUser,
	}, dispatch
);

class Component extends React.Component<Props, State> {
	
	public constructor(props: Props) {
		super(props);
		this.state = {...props.user, 
			submitted: false, 
			listingAgentRouting: this.props.user ? this.props.user.listingAgentRouting : false,
		}
	}

	private save() {
		const { saveUser } = this.props;
		const { listingAgentRouting } = this.state;
		const user: UserPartial = {
			listingAgentRouting,
		}
		saveUser({user});
	}

	public render() {
		const { listingAgentRouting } = this.state;
		const { checked, onToggle } = this.props;
		const controlled = onToggle !== undefined;
		return (
			<Mui.Grid container direction="column" spacing={2}>
				<Mui.Grid item>
					<Switch
						checked={controlled ? !!checked : !!listingAgentRouting}
						label={env.refreshDesignsDev ? "Assign featured listing leads to the listing agent" : "Always assign Featured Property leads to the listing agent"}
						description={env.refreshDesignsDev ? "When enabled, leads on featured listings are always assigned to the listing agent, overriding all other routing rules except First Touch Attribution." : "Overrides other lead routing unless lead is assigned via First Touch Lead Attribution."}
						onChange={controlled ? onToggle! : (checked) => this.setState({listingAgentRouting: checked}, () => this.save())}
					/>
				</Mui.Grid>
			</Mui.Grid>			
		);
	}
}

export const FeaturedTab = connect(mapStateToProps, mapDispatchToProps)(Component);